export default "__VITE_ASSET__m5MSDSQv__"